import { useTranslation } from 'react-i18next';
import NotFound from '../../../../components/not-found';
import type { NotificationItem } from '../../application/types';
import { useNotificationsList } from '../hooks/useNotificationsList';

function NotificationRow({ item }: { item: NotificationItem }) {
  return (
    <li className={`notification-list__item${item.isRead ? '' : ' unread'}`}>
      <p className="notification-list__item-title">{item.title}</p>
      <p className="notification-list__item-body">{item.body}</p>
      {item.createdAt ? (
        <span className="notification-list__item-date">
          {new Date(item.createdAt).toLocaleString()}
        </span>
      ) : null}
    </li>
  );
}

export function NotificationList() {
  const { t } = useTranslation();
  const { items, isLoading } = useNotificationsList();

  if (isLoading) {
    return (
      <section className="notification-list-container">
        <div className="notification-list notification-list--empty" />
      </section>
    );
  }

  if (items.length === 0) {
    return (
      <section className="notification-list-container">
        <div className="notification-list notification-list--empty">
          <NotFound message={t('notification.list.empty')} />
        </div>
      </section>
    );
  }

  return (
    <section className="notification-list-container">
      <ul className="notification-list">
        {items.map((item) => (
          <NotificationRow key={item.id} item={item} />
        ))}
      </ul>
    </section>
  );
}

export default NotificationList;
